import { AxiosResponse } from 'axios';

import AbstractSiteApi from '../AbstractSiteApi';

import { CounterData } from './Response/LotteryApi';

class LotteryApi extends AbstractSiteApi {
    protected endpoint: string = 'lottery/';

    public getCounterData(lottery: string): Promise<CounterData> {
        return this.get(`${lottery}/counter-data`).then((response: AxiosResponse) => response.data);
    }
}

export default new LotteryApi();
